import { useEffect, useState } from "preact/hooks";
import type { ChatApi, ProductFeatures } from "./api.ts";

/**
 * Ce que le back-office permet pour le livre ouvert (récap, explication, questions de départ…), lu une fois à
 * l'ouverture comme dans Studio : `undefined` tant qu'on ne sait pas, `null` si l'API ne répond pas ou sans chat.
 */
export function useBookFeatures(api: ChatApi | undefined, productId: string | undefined): ProductFeatures | null | undefined {
  const [features, setFeatures] = useState<ProductFeatures | null>();
  useEffect(() => {
    if (!api || !productId) {
      setFeatures(null);
      return;
    }
    let cancelled = false;
    setFeatures(undefined);
    api.getProductFeatures(productId).then(
      (found) => !cancelled && setFeatures(found),
      () => !cancelled && setFeatures(null),
    );
    return () => {
      cancelled = true;
    };
  }, [api, productId]);
  return features;
}
